import { Box } from '@mui/material';
import ProductCardV2 from '../../../../../../components/Product/components/ProductCardV2/ProductCardV2';
import { ProductCardV2Props } from '../../../../../../components/Product/components/ProductCardV2/types/productCardV2.types';
import { useCatalogDraggableItem } from '../../hooks/useCatalogDraggableItem';

export interface DraggableCardConfig {
  id: string;
  activeId: string | null;
  isDraggingDisabled: boolean;
}

interface DraggableProductCardProps {
  productCard: ProductCardV2Props;
  drag: DraggableCardConfig;
}

const DraggableProductCard = ({ productCard, drag }: DraggableProductCardProps) => {
  const { attributes, listeners, setActivatorNodeRef, setNodeRef } = useCatalogDraggableItem({
    id: drag.id,
    isDraggingDisabled: drag.isDraggingDisabled,
    data: { productCard },
  });

  const setCardRef = (node: HTMLElement | null) => {
    setNodeRef(node);
    setActivatorNodeRef(node);
  };

  const isActive = drag.activeId === drag.id;
  const isDragActive = drag.activeId !== null;

  return (
    <Box
      ref={setCardRef}
      test-id="draggable-product-card"
      {...attributes}
      {...listeners}
      sx={{
        height: '100%',
        opacity: isActive ? 0.4 : 1,
        cursor: drag.isDraggingDisabled ? 'default' : 'grab',
        pointerEvents: isDragActive ? 'none' : undefined,
      }}
    >
      <ProductCardV2 {...productCard} />
    </Box>
  );
};

export default DraggableProductCard;
